import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import Layout from 'components/Layout';
import Meta from 'components/Meta';
import Banner from 'components/Banner';
import SectionContact from 'components/SectionContact';

import CheckIcon from 'images/icons/check.svg';

import { SolutionsDetail } from 'styles/solutions-detail';
import SolutionSteps from '../../components/SolutionSteps/SolutionSteps';

const SolutionEWDPage = ({ path }) => (
  <>
    <Meta title="Enterprise Web Development | Solutions" />
    <Layout background="#ffffff" path={path}>
      <SolutionsDetail>
        <Banner
          backgroundSrc="partners/partners-bg.jpg"
          title="Enterprise Web Development - Offer Solutions."
          className="darken-image"
          style={{ paddingBottom: 100 }}
        >
          <p
            className="white-txt"
            style={{
              fontSize: 18,
              letterSpacing: 0.2,
              lineHeight: '28px',
            }}
          >
            Web design and development paired with an understanding of user
            experience turns your product into a solution.
          </p>
          <Link
            to="/contact-us/"
            className="pink-btn"
            style={{ minWidth: 180 }}
          >
            <span>Scope your project</span>
          </Link>
          <a
            href="#brief"
            onClick={(e) => {
              e.preventDefault();
              if (typeof window !== 'undefined')
                window.scrollb.scrollIntoView(document.getElementById('brief'));
            }}
            className="white-btn brief-btn"
          >
            <span>What to expect</span>
          </a>
        </Banner>

        <section className="principle-main">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-lg-8">
                <h2 className="medium-heading">
                  Web application for enterprise
                </h2>
                <p className="white-txt">
                  As the internet becomes ubiquitous and browsers become faster
                  and more secure, there is exponential growth in the volume and
                  variety of web applications. From e-commerce, real estate,
                  travel, news digests, to light versions like social media
                  apps, we find relevance and use cases across many industries
                  and purposes. Since web applications are delivered through
                  browsers, it offers truly device-agnostic simplicity and
                  consistent experience across platforms.
                </p>
              </div>
            </div>
          </div>
        </section>

        <SolutionSteps
          id="enterpriseWebDevelopment"
          flyText="Enterprise Web Development"
        />

        <section id="brief">
          <div className="grey-bg center">
            <div className="container">
              <div className="featured-partner-block">
                <h2 className="medium-heading black-txt">
                  Development Made Simple
                </h2>
                <p>
                  ATC uses DevOps and Scrum to shorten the development time,
                  speed-up time to market and add incremental value with every
                  release, whether it be conventional software, business
                  applications, mobile, or web apps. Our expertise spans across
                  <span className="pink"> Angular and React </span>
                  for front-end and optimal user experience while the
                  server-side utilizes
                  <span className="pink">
                    &nbsp;Ruby, Python, Node.js, Java and PHP.
                  </span>
                </p>
                <Link
                  to="/contact-us/"
                  className="pink-btn d-none d-md-inline-block"
                >
                  <span>Talk to an Expert</span>
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="why-partner-main">
            <div className="container">
              <div className="row">
                <div className="col-md-4">
                  <h2 className="big-heading">
                    What to expect
                    <span className="pink">.</span>
                  </h2>
                </div>
                <div className="col-md-8">
                  <div className="row">
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Build</h3>
                        <p>High performance teams.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Deploy</h3>
                        <p>Continuous delivery.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Monitor</h3>
                        <p>Client notification at every step.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-6">
                      <div className="why-partner-single">
                        <span className="why-partner-icon">
                          <CheckIcon />
                        </span>
                        <h3>Manage</h3>
                        <p>Ongoing analytics for optimal user experience.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <SectionContact />
      </SolutionsDetail>
    </Layout>
  </>
);

SolutionEWDPage.propTypes = {
  path: PropTypes.string.isRequired,
};

export default SolutionEWDPage;
